<ng-container *ngIf="dataSource">
  <div>
    <ng-container *ngFor="let item of dataSource | async; let index = index">
      <div class="card-info" (click)="handleCardAction(item, index)">
        <ng-container *ngFor="let header of headers">
          <ng-container *ngIf="header.toRender">
            <sit-renderer [toRender]="resolveRenderData(header.toRender, item[header.key], header.key, index, item)" />
          </ng-container>
          <div class="card-info-item">
            <span *ngIf="header.label?.toLowerCase() === 'id'" class="upcase-text">
              {{ header.label }}
            </span>
            <svg *ngIf="header.key === 'statusName'" width="1.25em" height="1em" viewBox="0 0 16 16">
              <circle cx="8" cy="11" r="4" [attr.fill]="(item[header.key]==='INACTIVO') ? 'red' : '#2AC527'"></circle>
            </svg>
            <span [ngClass]="{'capitalize-header': header.key === 'statusName'}">
              <span *ngIf="header.label === '-'"> - </span>{{ item[header.key] }}
            </span>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-container>
